import { render, staticRenderFns } from "./start.vue?vue&type=template&id=6129fc33&scoped=true"
import script from "./start.vue?vue&type=script&lang=js"
export * from "./start.vue?vue&type=script&lang=js"
import style0 from "./start.vue?vue&type=style&index=0&id=6129fc33&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6129fc33",
  null
  
)

export default component.exports